module.exports = __webpack_public_path__ + "media/images/video/clubpilates-go-logo-6b1bfe3fdb9ee922d8d7c88af7fe042a.png";